import { render, staticRenderFns } from "./BrowserSupport.vue?vue&type=template&id=f2264f0c&lang=html&"
import script from "./BrowserSupport.vue?vue&type=script&lang=js&"
export * from "./BrowserSupport.vue?vue&type=script&lang=js&"
import style0 from "./BrowserSupport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports